import '../assets/css/bootstrap.css';
import '../assets/icons/font-awesome/css/font-awesome.css';

import React, { useEffect, useState, useRef } from "react";
import {useNavigate, useParams} from "react-router-dom";
import styled, { ThemeContext } from "styled-components";
import {getPrivacidade} from "../services/api";

export const Privacidade = () => {
    const {id} = useParams<string>();
    const [privacidade,setPrivacidade] = useState<{Privacidade: string, Cor : string, Logo : string}>();
    function handleOnLoad(event : any){
        event.target.style.height =
              event.target.contentWindow.document.body.scrollHeight + 20 + 'px';
    }

    useEffect(() => {        
        var params = "";
        if(id){
            params = "numeroSerie=" + id;
        }

        getPrivacidade(params).then((res : any) => {      
            setPrivacidade(res); 
         });
       
    },[]);


    return(
    
            <PRIVACIDADE>
                 <iframe
                style={{borderWidth:0, width:"100%", height: "100%"}}
                    id="iframe_certificado"
                    name="iframe_certificado"
                    sandbox="allow-same-origin"
                    srcDoc={privacidade?.Privacidade}
                    onLoad={handleOnLoad}
                ></iframe>

            </PRIVACIDADE>
    )
}

const PRIVACIDADE = styled.section`

`;